




















import { Component, Prop, Vue } from "vue-property-decorator";
import { OpsiRah } from "@/types/rekam_asuhan_hemodialisis";

@Component({})
export default class PilihanChip extends Vue {
  @Prop({ default: null }) readonly value!: string | string[] | null;
  @Prop({ type: Array, default: () => [] }) readonly items!: OpsiRah[];
  @Prop({ type: Boolean, default: false }) readonly multiple!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "" }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly wajib!: boolean;

  get daftar(): string[] {
    if (Array.isArray(this.value)) return this.value;

    return this.value ? [this.value] : [];
  }

  terpilih(nilai: string): boolean {
    return this.daftar.includes(nilai);
  }

  pilih(nilai: string) {
    if (this.disabled) return;

    if (this.multiple) {
      const hasil = this.terpilih(nilai)
        ? this.daftar.filter(it => it !== nilai)
        : [...this.daftar, nilai];
      const urutan = this.items.map(it => it.value);
      hasil.sort((a, b) => urutan.indexOf(a) - urutan.indexOf(b));
      this.$emit("input", hasil);
      return;
    }

    if (this.terpilih(nilai) && this.wajib) return;

    this.$emit("input", this.terpilih(nilai) ? null : nilai);
  }
}
